import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import RedoIcon from "@mui/icons-material/Redo";
import GradeIcon from "@mui/icons-material/Grade";
import Skeleton from "@mui/material/Skeleton";
import { images } from "../../../constants";
import { getAsset, formatCurrencyCode } from "../../../helpers/helper";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";

const ShopItemCard = ({
  item,
  isProperty,
  shopid,
  setShowmodal,
  setShareurl,
  setShow,
  UserShopView,
  shopData,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [imgLoading, setImgLoading] = useState(true);

  const Items = item.data;
  let name =
    location.pathname === `/Byvehicleuserprofile/${shopid}`
      ? Items?.brandName
      : Items?.itemname || Items?.subCategory || "Item Name";
  const rawImg = Items?.images?.[0] || Items?.image?.[0];
  let image = rawImg ? getAsset(rawImg) : noImagePlaceholder;
  let stock = Items?.stock || 0;
  let currency = formatCurrencyCode(Items?.currency);
  let price = Items?.price || 0;
  let id = Items?._id;

  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2">
      <div className="ShopsCards mt-2 mb-2">
        {!isProperty ? (
          <div className="fix-img position-relative">
            {Items?.specialoffer?.length > 0 ? (
              <p className="mb-0 position-absolute p-1 bg-danger text-white font_12 z-index-1">
                {Items?.specialoffer}
              </p>
            ) : Items?.salespromotion?.length > 0 ? (
              <p className="mb-0 position-absolute p-1 bg-danger text-white font_12 z-index-1">
                {Items?.salespromotion}
              </p>
            ) : null}
            {imgLoading && (
              <Skeleton 
                variant="rectangular" 
                width="100%" 
                height="100%" 
                style={{ position: 'absolute', top: 0, left: 0 }} 
              />
            )}
            <img
              className="card-img img-fluid"
              src={image}
              alt=""
              style={{
                objectFit: "cover",
                width: "100%",
                height: "-webkit-fill-available",
                display: imgLoading ? 'none' : 'block'
              }}
              crossOrigin="anonymous"
              onLoad={() => setImgLoading(false)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImagePlaceholder;
                setImgLoading(false);
              }}
            />
          </div>
        ) : (
          <div className="fix-img position-relative" style={{ height: "180px" }}>
             {imgLoading && (
              <Skeleton 
                variant="rectangular" 
                width="100%" 
                height="100%" 
                style={{ position: 'absolute', top: 0, left: 0 }} 
              />
            )}
            <img
              className="card-img img-fluid"
              src={image}
              alt=""
              style={{
                objectFit: "cover",
                width: "100%",
                height: "-webkit-fill-available",
                display: imgLoading ? 'none' : 'block'
              }}
              crossOrigin="anonymous"
              onLoad={() => setImgLoading(false)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImagePlaceholder;
                setImgLoading(false);
              }}
            />
          </div>
        )}
        <div className="border">
          <div>
          
<Row className="align-items-center pt-2 flex-nowrap">
  <Col className="overflow-hidden">
    <p className="mb-0 ps-2 pe-2 items-card-font fw-bold text-truncate">
      {String(name).slice(0, 8) + (String(name).length > 8 ? "..." : "")}
    </p>
  </Col>

  {isProperty ? (
    <Col xs="auto" className="flex-shrink-0">
      <p
        className="mb-0 ps-2 pe-2 me-2 stock cursor_P d-flex align-items-center justify-content-center"
        onClick={() => {
          setShowmodal(true);
          if (setShareurl) {
            setShareurl(`/single-property-addview/${id}`);
          }
        }}
        style={{
          backgroundColor: "#0353A4",
          color: "white",
          whiteSpace: "nowrap",
          gap: "5px",
        }}
      >
        <RedoIcon className="share_icon_f flex-shrink-0" />
        Share
      </p>
    </Col>
  ) : (
    <Col xs="auto">
      <p className="mb-0 ps-1 pe-1 mt-1 stock me-2">
        {stock} Stock
      </p>
    </Col>
  )}
</Row>
            <Row className="ps-2 ">
              <Col lg={6} className="ps-1 pe-0">
                <p className="mb-0 ps-2 pe-2 pt-1 items-card-font font-blue">
                 {currency}&nbsp;
{String(price).slice(0, 3) + (String(price).length > 3 ? ".." : "")}
                </p>
              </Col>
              <Col lg={6} className="p-0 text-center mt-1">
                {" "}
                <div style={{ color: "black", fontSize: "12px" }}>
                  <b>
                    <GradeIcon
                      style={{
                        fontSize: "medium",
                        color: "#FFE507",
                      }}
                    />
                    ({item?.rating ? Number(item.rating).toFixed(1) : "0.0"})
                  </b>
                </div>
              </Col>
            </Row>

            <div className="row align-items-center mb-1">
              <Col lg="6" xs="6" md="6" sm="6" className="pe-0">
                <h6 className="items-card-font ms-3 mb-0">Orders ({item?.orders || 0})</h6>
              </Col>
            </div>
          </div>
          <div className="d-flex justify-content-around pt-1 pb-1 mb-1 mt-1">
            <p
              className="mb-0 ps-lg-4 pe-lg-4 view_btn-User"
              onClick={() => {
                location?.pathname === `/Byvehicleuserprofile/${shopid}`
                  ? navigate(`/buy-usedvehicle-view/${id}`)
                  : setShow(true);
                UserShopView(id);
              }}
            >
              View
            </p>
          </div>
          <div className="margin-Boxes">
            <Row className="row bg-blue shop-item-contact-actions">
              <Col
                lg={6}
                md={4}
                className="p-0"
                onClick={() => {
                  const ownerId = shopData?.userid?._id || shopData?.userid || Items?.userid?._id || Items?.userid;
                  if (ownerId) {
                    const targetUser = {
                      _id: ownerId,
                      fullname: shopData?.userid?.fullname || shopData?.username || Items?.userid?.fullname || shopData?.shopname || "Shop Owner",
                      image: shopData?.userid?.imageUrl?.[0] || shopData?.userid?.profilePic || Items?.userid?.imageUrl?.[0] || shopData?.image || null,
                      position: "User",
                      businessType: shopData?.businessType || "generalPublic",
                    };
                    localStorage.setItem("messengerTargetUser", JSON.stringify(targetUser));
                    window.dispatchEvent(new CustomEvent("open-messenger", { detail: targetUser }));
                  }
                }}
              >
                <div className="border-end cursor">
                  <p className="mb-0 ps-1 d-flex justify-content-center p-1">
                    <img
                      className="w-img-card"
                      src={images?.Mail}
                      alt="Mail icon"
                    />
                    <span className="btns text-white ps-1">Message</span>
                  </p>
                </div>
              </Col>
              <Col lg={6} md={4} className="p-0">
                <div className="cursor">
                  <p className="mb-0 ps-1 d-flex justify-content-center p-1">
                    <img
                      className="w-img-card"
                      src={images?.Phone}
                      alt="Phone icon"
                    />
                    <span className="btns text-white ps-1">Call</span>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopItemCard;
